Ext.define('SA.CrosstabLoadingCell', {
    constructor({parent}) {
        this.el = parent.appendChild(document.createElement('div'));
        this.el.className = 'sa-crosstab-loading-cell';
    },

    setState(state) {
        this.el.classList.toggle('sa-crosstab-loading-cell-dragging', state.dragging);
    },

    setVisible(visible) {
        this.el.classList.toggle('sa-crosstab-loading-cell-hidden', !visible);
    }
});